import React, { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { Button } from "react-bootstrap";
import { useDispatch, useSelector } from 'react-redux';
import { createUser, updateUser } from "../../store/slices/users/createUser";
import { fetchRoles } from "../../store/slices/rolesAndPermissions/rolesAndPermissions";

const UsersForm = (props) => {
    const { onNewSubmit, user } = props;

    const [status, setStatus] = useState('');
    const dispatch = useDispatch();

    const mobileReg = /^[6-9]\d{9}$/;

    const userSchema = Yup.object().shape({
        name: Yup.string().required('Name is required'),
        mobile: Yup.string()
            .required('Mobile is required')
            .matches(mobileReg, 'Please enter valid mobile number'),
        email: Yup.string().email("Invalid email").required('Email is required'),
        roleId: Yup.number().required("Role is required")
    });

    const { rolesList } = useSelector(
        (state) => state.rolesAndPermissionReducer
    );

    useEffect(() => {
        if (!status) {
            setStatus(user?.status === 0 || user?.status === 1 ? user.status : 1);
        }
    }, [status, user]);

    useEffect(() => {
        dispatch(fetchRoles({ limit: 1000, page: 1 }));
    }, [dispatch]);

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            name: user?.name || "",
            mobile: user?.mobile || "",
            email: user?.email || "",
            roleId: user?.role?.id || "",       // pre-select user role
            status: user?.status ?? 1,
            password: "",
            confirmPassword: ""
        },
        validationSchema: userSchema,
        onSubmit: (values) => {
            values.status = status;

            if (user?.id) {
                values.id = user.id;

                if (!values.password) delete values.password;
                if (!values.confirmPassword) delete values.confirmPassword;

                dispatch(updateUser(values));
            } else {
                dispatch(createUser(values));
            }

            onNewSubmit(true);
        }
    });

    return (
        <form onSubmit={formik.handleSubmit}>

            <div className="form-group row">
                <label className="col-sm-2 col-form-label">Name</label>
                <div className="col-sm-10">
                    <input
                        type="text"
                        className="form-control"
                        name="name"
                        onChange={formik.handleChange}
                        value={formik.values.name}
                    />
                    {formik.touched.name && formik.errors.name && (
                        <span className="text-danger">{formik.errors.name}</span>
                    )}
                </div>
            </div>

            <div className="row mt-4">
                <label className="col-sm-2 col-form-label">Mobile</label>
                <div className="col-sm-10">
                    <input
                        className="form-control"
                        type="text"
                        name="mobile"
                        onChange={formik.handleChange}
                        value={formik.values.mobile}
                    />
                    {formik.touched.mobile && formik.errors.mobile && (
                        <span className="text-danger">{formik.errors.mobile}</span>
                    )}
                </div>
            </div>

            <div className="row mt-4">
                <label className="col-sm-2 col-form-label">Email</label>
                <div className="col-sm-10">
                    <input
                        className="form-control"
                        type="email"
                        name="email"
                        onChange={formik.handleChange}
                        value={formik.values.email}
                    />
                    {formik.touched.email && formik.errors.email && (
                        <span className="text-danger">{formik.errors.email}</span>
                    )}
                </div>
            </div>

            <div className="row mt-4">
                <label className="col-sm-2 col-form-label">Role</label>
                <div className="col-sm-10">
                    <select
                        className="form-select"
                        name="roleId"
                        value={formik.values.roleId}
                        onChange={formik.handleChange}
                    >
                        <option value="">Select Role</option>
                        {rolesList?.map((r) => (
                            <option key={r.id} value={r.id}>
                                {r.name}
                            </option>
                        ))}
                    </select>

                    {formik.touched.roleId && formik.errors.roleId && (
                        <span className="text-danger">{formik.errors.roleId}</span>
                    )}
                </div>
            </div>

            <div className="form-group row mt-3">
                <label className="col-sm-2 col-form-label">Status</label>
                <div className="col-sm-10 d-flex">
                    <div className="form-check me-3">
                        <input
                            className="form-check-input"
                            type="radio"
                            name="status"
                            value="1"
                            checked={+status === 1}
                            onChange={(e) => setStatus(e.target.value)}
                        />
                        <label className="form-check-label">Active</label>
                    </div>

                    <div className="form-check">
                        <input
                            className="form-check-input"
                            type="radio"
                            name="status"
                            value="0"
                            checked={+status === 0}
                            onChange={(e) => setStatus(e.target.value)}
                        />
                        <label className="form-check-label">Inactive</label>
                    </div>
                </div>
            </div>

            <div className="text-center mt-4">
                <Button variant="primary" className="btn-lg" type="submit">
                    Submit
                </Button>
            </div>
        </form>
    );
};

export default UsersForm;
